import { Component, OnDestroy, OnInit } from "@angular/core";
import { Hub } from "aws-amplify/utils";
import { AuthService } from "./services/auth.service";
import { MaintenanceService } from "./services/maintenance.service";
import { NavigationHistoryService } from "./shared/services/navigation-history.service";

@Component({
  standalone: false,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  private hubListenerCancel?: () => void;

  constructor(
    private authService: AuthService,
    private maintenance: MaintenanceService,
    // Eagerly instantiate so router events are tracked from app boot,
    // before BaseComponent is created and CRM navigation begins.
    _navHistory: NavigationHistoryService
  ) {}

  // Resolved by the APP_INITIALIZER before the app boots.
  get maintenanceOn(): boolean {
    return this.maintenance.enabled;
  }

  get maintenanceMessage(): string {
    return this.maintenance.message;
  }

  ngOnInit(): void {
    // Global session monitor: if Cognito cannot refresh the token,
    // the session is permanently dead — force logout immediately.
    this.hubListenerCancel = Hub.listen("auth", ({ payload }) => {
      if (payload.event === "tokenRefresh_failure") {
        console.warn("Amplify Hub: tokenRefresh_failure — forcing logout.");
        this.authService.logout();
      }
    });
  }

  ngOnDestroy(): void {
    this.hubListenerCancel?.();
  }
}
